import { EarnMask } from "../../models/types/earn.types";

export const INITIAL_DEFAULT_MASK: EarnMask = {
  columns: {},
  rows: {},
  cells: {},
  name: "",
  publishedAt: null,
  maskId: crypto.randomUUID(),
  appliedToSet: new Set(),
  appliedToArray: [],
  version: 0,
  status: "draft",
  updatedAt: null,
};
